<script>
    import _            from 'lodash'
    import * as api     from '../shared/api.js'
    import { appdata }  from '../shared/stores.js'
    import AppLoader    from '../shared/Loader.svelte'
    import SectionTitle from '../shared/SectionTitle.svelte'
    import Company      from './Company.svelte' 

    const toAdd = { id: 0, name: '', cnpj: '' }
    let active  = -1
    let companies = []
    let loading = true
    let error = false
    
    function onRemove(it) {
        companies = companies.filter(c => c.id !== it.id)
        $appdata.companies = companies.map(it => {
            return {id: it.id, name: it.name}
        })

    }
    function onUpdate(it) {
        const filtered = companies.filter(c => c.id !== it.id)
        companies = _.sortBy([...filtered, it], i => i.name)
        $appdata.companies = companies.map(it => {
            return {id: it.id, name: it.name}
        })
    }

    api
        .get('/companies')
        .then(res => {
            loading = false
            if(res.status === 200)
                return res.json()
            else
                throw 'Erro Carregando Dados'
        })
        .then(list => {
            companies = list
        })
        .catch(error => {
            loading = false
        })


</script>

{#if loading || error}
    <AppLoader {error} what="Carregando"  inverted={true}/>
{:else}
    <SectionTitle>Empresas</SectionTitle>
    <div class="ui raised segments">
        <!-- <div class="ui segment">{active}</div> -->
        <Company company={toAdd} 
                bind:active
                {onUpdate}/>
        {#each companies as company (company.id)}
            <Company bind:company
                     bind:active
                     {onRemove}
                     {onUpdate}>
                <span slot="header">
                    <span data-annotation={ JSON.stringify({ type: "company", name: company.name, target: company }) } class="name annotation-source">{company.name}</span>
                    <span class="description">{company.cnpj}</span>                 
                </span>
            </Company>
        {/each}    
    </div>
{/if}